import React, { useState } from 'react';
import { Input } from './ui/input';
import { Eye, EyeOff } from 'lucide-react';

/**
 * Password input with show/hide toggle.
 * Accepts all standard Input props.
 */
export default function PasswordInput({ className = '', readOnly = false, ...props }) {
  const [show, setShow] = useState(false);

  return (
    <div className="relative">
      <Input
        {...props}
        readOnly={readOnly}
        type={show ? 'text' : 'password'}
        className={`pr-10 ${readOnly ? 'bg-slate-50 cursor-default' : ''} ${className}`}
      />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setShow(v => !v)}
        className="absolute inset-y-0 right-0 flex items-center px-3 text-slate-400 hover:text-slate-700 transition-colors focus:outline-none"
        aria-label={show ? 'Скрий паролата' : 'Покажи паролата'}
      >
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
}
